enum FeatureFlags {
  PARTNER_SESSIONS_ENABLED = 'partner-sessions-enabled',
  ENERGY_SHOW_SVT_ALERT = 'energy-show-svt-alert',
  EV_ENABLED = 'ev-enabled',
  RS_SCROLL_SYNC = 'rs-scroll-sync',
  PARTNER_POPUP_ENABLED = 'partner-popup-enabled',
  PAPER_BILLING_ENABLED = 'paper-billing-enabled',
  PARTNER_BANNER_ENABLED = 'partner-banner-enabled',
  BROADBAND_APPOINTMENT_BOOKING = 'broadband-appointment-booking',
  OPTIONAL_VOIP = 'optional-voip',
  PARTNER_PRESENTATION_REWORK_ENABLED = 'partner-presentation-rework-enabled',
  NEW_REMOTE_JOURNEY = 'new-remote-journey',
}

enum MixpanelFlags {
  BUNDLE_TILE_COPY = 'bundle_tile_copy',
}

type BundleTileCopyVariant = 'old' | 'new';

type MixpanelFlagValues = {
  [MixpanelFlags.BUNDLE_TILE_COPY]: BundleTileCopyVariant;
};

export { FeatureFlags, MixpanelFlags };
export type { BundleTileCopyVariant, MixpanelFlagValues };
